import Textarea from "@mui/joy/Textarea";
import {
  Box,
  Button,
  Divider,
  FormControl,
  Paper,
  Snackbar,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import { sendRequestForm } from "api/sendRequestForm";
import React, { useState } from "react";
import { useCart } from "../context/CartContext";
import { useModal } from "../context/ModalContext";

const textFieldStyles = {
  "& .MuiInputBase-root": {
    color: "#000",
  },
  "& .MuiInputLabel-root": {
    color: "#424242",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#424242",
      color: "#424242",
    },
    "&:hover fieldset": {
      borderColor: "#424242",
      color: "#424242",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#424242",
      color: "#424242",
    },
  },
  "& .MuiInputBase-input::placeholder": {
    color: "#424242",
  },

  "& .MuiInputLabel-root.Mui-focused": {
    color: "#424242",
  },
};

function RequestFormGuest() {
  const { requestFormItems, removeItemFromRequestForm, emptyRequestForm } =
    useCart();
  const { setIsCheckoutOpen } = useModal();
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    name: "",
    phone: "",
    orderNumber: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSnackbar(false);
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  const validatePhone = (phone) => {
    const re = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/;
    return re.test(phone);
  };

  const validateForm = () => {
    let tempErrors = {};

    if (!formData.email) tempErrors.email = "Email er påkrævet";
    else if (!validateEmail(formData.email)) tempErrors.email = "Ugyldig email";

    if (!formData.name) tempErrors.name = "Navn er påkrævet";

    if (!formData.phone) tempErrors.phone = "Telefon er påkrævet";
    else if (!validatePhone(formData.phone))
      tempErrors.phone = "Ugyldigt telefonnummer";

    if (!formData.orderNumber)
      tempErrors.orderNumber = "Ordre / Sags nummer er påkrævet";

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (requestFormItems.length > 0) {
      if (validateForm()) {
        try {
          await sendRequestForm(formData, requestFormItems);

          setIsCheckoutOpen(false);
          emptyRequestForm();
        } catch (error) {
          console.error("Error submitting request:", error);
        }
      } else {
      }
    } else {
      setOpenSnackbar(true);
    }
  };
  const handleDeleteRow = (id) => {
    removeItemFromRequestForm(id);
  };

  return (
    <>
      <Divider />
      <Box
        aria-labelledby="request-modal-title"
        aria-describedby="request-modal-description"
        component="form"
        onSubmit={handleSubmit}
      >
        <Box mb={2}>
          <FormControl fullWidth margin="normal">
            <TextField
              label="Kontakt E-mail"
              placeholder="Kontakt E-mail"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              error={!!errors.email}
              helperText={errors.email}
              sx={textFieldStyles}
              required
            />
          </FormControl>
          <FormControl fullWidth margin="normal">
            <TextField
              label="Navn"
              placeholder="Navn"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              error={!!errors.name}
              helperText={errors.name}
              sx={textFieldStyles}
              required
            />
          </FormControl>
          <FormControl fullWidth margin="normal">
            <TextField
              label="Telefon"
              placeholder="Telefon"
              name="phone"
              value={formData.phone}
              onChange={handleInputChange}
              error={!!errors.phone}
              helperText={errors.phone}
              sx={textFieldStyles}
              required
            />
          </FormControl>
          <FormControl fullWidth margin="normal">
            <TextField
              label="Ordre / Sags nummer"
              placeholder="Ordre / Sags nummer"
              name="orderNumber"
              value={formData.orderNumber}
              onChange={handleInputChange}
              error={!!errors.orderNumber}
              helperText={errors.orderNumber}
              sx={textFieldStyles}
              required
            />
          </FormControl>
        </Box>

        <Divider />
        <Box my={2}>
          <TableContainer
            component={Paper}
            sx={{ maxHeight: "200px", overflow: "auto" }}
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>Ref.Nummer</TableCell>
                  <TableCell>Antal</TableCell>
                  <TableCell>Handlinger</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {requestFormItems.map((item, id) => (
                  <TableRow key={item.id}>
                    <TableCell>{item.name}</TableCell>
                    <TableCell>
                      {item.type === "machine" ? "" : item.quantity}
                    </TableCell>
                    <TableCell>
                      <Button
                        variant="outlined"
                        color="error"
                        onClick={() => handleDeleteRow(item.id)}
                      >
                        Slet
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        <Divider />
        <Box>
          <FormControl fullWidth margin="normal" my={1}>
            <Textarea
              minRows={5}
              placeholder="info til JL Filtersystem"
              name="message"
              value={formData.message}
              onChange={handleInputChange}
              sx={{ width: "100%", height: "80px" }}
            />
          </FormControl>
        </Box>
        <Divider my={1} />

        <Stack direction="row" spacing={2} my={1}>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            onClick={handleSubmit}
            sx={{
              mt: 3,
              mb: 2,
              bgcolor: "#424242",
              "&:hover": {
                bgcolor: "#686868",
              },
            }}
          >
            Send besked
          </Button>
          <Button
            type="button"
            fullWidth
            variant="outlined"
            sx={{
              mt: 3,
              mb: 2,
              color: "#424242",
              borderColor: "#424242",
              "&:hover": {
                bgcolor: "#686868",
                color: "#fff",
                borderColor: "#424242",
              },
            }}
            onClick={() => setIsCheckoutOpen(false)}
          >
            Tilbage
          </Button>
        </Stack>
        <Snackbar
          open={openSnackbar}
          autoHideDuration={3000}
          onClose={handleCloseSnackbar}
          message="Du kan ikke sende basket, hvis kurven er tom."
        />
      </Box>
    </>
  );
}

export default RequestFormGuest;
